import React from 'react';
import { renderLayerDom } from '@/utils/render-kit';
import { ILayerProps } from '@/version-types';
import MarkupImage from './markup-image';

export function renderDom(layer: ILayerProps): Promise<() => void> {
    return new Promise((resolve) => {
        const removeDomHandle = renderLayerDom(
            <MarkupImage
                layer={layer}
                renderEnd={() => {
                    resolve(removeDomHandle);
                }}
            />,
        );
    });
}
